import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for Overlay module:
 */

export default defineSlotRecipe({
    slots: [
        'root',
        'imageContainer',
        'container',
        'textContainer',
        'headline',
        'copy',
        'buttonGroup'
    ],
    base: {
        root: {
            flexDirection: 'column',
            gap: {base: 'spacing-24', s: 'spacing-40'},
            color: 'text.primary'
        },
        imageContainer: {borderRadius: 's', overflow: 'hidden'},
        container: {flexDirection: 'column', gap: 'spacing-24'},
        textContainer: {flexDirection: 'column', gap: 'spacing-12'},
        headline: {textStyle: 'heading.large'},
        copy: {
            color: 'text.secondary',
            textStyle: 'body.medium'
        },
        buttonGroup: {}
    }
})
